module.exports = function (blocker, msg) {
  var loader_class = blocker == true ? 'blocker' : 'non-blocker';
  var html = "<div id=\"saito-loader-container\" class=\"saito-loader-container ".concat(loader_class, "\"");
  if (msg) {
    html += " title=\"".concat(msg, "\"");
  }
  html += "> \n    <div class=\"saito-loader\">\n    </div>\n </div>";
  return html;
};